import type { Dispatch, SetStateAction } from 'react'
import { type FC, useMemo } from 'react'

import { NavPills } from '@space-lib/components/navPills'
import useTranslation from '@space-lib/hooks/useTranslation'

import { COMMUNITY_TYPE } from '@space-shell/modules/communities/accessAndPrivacy/constants'
import useCommunityConfigurationSidebar from '@space-shell/modules/communities/communityConfigurationSidebar/hooks/useConfigurationCommunitySidebar/useCommunityConfigurationSidebar'

import { TabTypes } from '../../types'

export type ModerationFiltersProps = {
  onClick: (page: TabTypes) => void
  page: TabTypes
  setPage: Dispatch<SetStateAction<TabTypes>>
}

const ModerationFilters: FC<ModerationFiltersProps> = ({ onClick, page, setPage }) => {
  const { t } = useTranslation()
  const { community } = useCommunityConfigurationSidebar()

  const items = useMemo(() => {
    const baseItems = [
      {
        pageName: TabTypes.FOLLOWER,
        label: t('configuration_sidebar.members_and_permissions.filters.members'),
        onClick
      },
      {
        pageName: TabTypes.MODERATOR,
        label: t('configuration_sidebar.members_and_permissions.filters.moderator'),
        onClick
      },
      {
        pageName: TabTypes.ADMIN,
        label: t('configuration_sidebar.members_and_permissions.filters.admin'),
        onClick
      }
    ]

    if (community.type === COMMUNITY_TYPE.EXCLUSIVE) {
      baseItems.push({
        pageName: TabTypes.IMPORT_HISTORY,
        label: t('configuration_sidebar.members_and_permissions.import_history.title'),
        onClick
      })
    }

    return baseItems
  }, [t, onClick, community.type])

  return (
    <NavPills>
      {items.map((item, i) => (
        <NavPills.Item
          key={`${item.label}-${i}`}
          isActive={item.pageName === page}
          onClick={() => {
            setPage(item.pageName)
            item.onClick(item.pageName)
          }}>
          {item.label}
        </NavPills.Item>
      ))}
    </NavPills>
  )
}

export default ModerationFilters
